declare namespace $ {

	export class $bog_ui_skeleton extends $mol_view {
	}
	
}

//# sourceMappingURL=skeleton.view.tree.d.ts.map